import Cookies from 'js-cookie';
import { AuthProxyUrlBuilder } from './AuthProxyUrlBuilder';
/** @internal */
export class ResourceCaller {
    constructor(authServiceOptions) {
        this.authServiceOptions = authServiceOptions;
    }
    async call(method, resourceHostId, path, payload, additionalHeaders) {
        return fetch(this.getProxyUrl(resourceHostId, path), {
            method,
            headers: Object.assign(Object.assign({}, additionalHeaders), this.createCsrfHeader()),
            credentials: 'include',
            body: payload,
        });
    }
    getProxyUrl(resourceHostId, path) {
        return AuthProxyUrlBuilder.getProxyUrl(this.authServiceOptions, resourceHostId, path);
    }
    // eslint-disable-next-line class-methods-use-this
    // eslint-disable-next-line @typescript-eslint/naming-convention
    createCsrfHeader() {
        const csrfToken = Cookies.get('csrf_token') || Cookies.get('myaudi-csrf-token') || '';
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { 'X-CSRF-TOKEN': csrfToken };
    }
}
//# sourceMappingURL=ResourceCaller.js.map